import axios from "axios";
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

const providers_list_el = document.querySelector('#providers-list');
const partners_per_page_el = document.querySelector('[name="partners_per_page"]');
const providers__button_el = document.querySelector('.providers__button');

const getParams = (overrides = {}) => {
    const term_id = document.querySelector('.providers-sidebar__link.active')?.getAttribute('data-term_id') ?? null;
    const sort = document.querySelector('.providers-sort .dropdown__item.active')?.getAttribute('data-value') ?? null;
    const s = document.querySelector('.providers-search [name="s"]')?.value.trim() ?? '';
    const per_page = partners_per_page_el.value;

    return {
        per_page,
        current_page: 1,
        term_id,
        sort,
        s,
        ...overrides
    };
};

const getPartners = (params) => {
    axios.get(api_settings.ajax_url, {
        params: {
            nonce: api_settings.nonce,
            action: 'load_more_partners',
            ...params,
        }
    })
        .then(function (response) {
            const data = response.data;

            if (!data.success) {
                Toastify({ text: data.message, style: { background: "red" } }).showToast();
                return;
            }

            const { current_page, total_pages, posts_html } = data.data;

            providers__button_el.style.display = current_page >= total_pages ? 'none' : '';
            providers__button_el.setAttribute('data-current-page', current_page);

            if (params.is_load_more) {
                providers_list_el.innerHTML += posts_html;
            } else {
                providers_list_el.innerHTML = posts_html;
            }
        })
        .catch(function (error) {
            console.log(error);
            Toastify({ text: 'Something went wrong', style: { background: "red" } }).showToast();
        })
        .finally(function () {
            providers__button_el.removeAttribute('disabled');
        });
};

// Load more
providers__button_el?.addEventListener('click', function () {
    const _el = this;
    _el.setAttribute('disabled', 'disabled');

    const current_page = _el.getAttribute('data-current-page');
    getPartners(getParams({ current_page, is_load_more: true }));
});

// Sidebar filter
document.querySelectorAll('.providers-sidebar__link').forEach((item, index) =>
    item.addEventListener('click', function () {
        document.querySelectorAll('.providers-sidebar__link').forEach((subitem, subindex) => {
            if (subindex !== index) subitem.classList.remove('active');
        });

        item.classList.toggle('active');
        getPartners(getParams({ current_page: 1 }));
    })
);

document.querySelector('.providers-sort')?.addEventListener('dropdown_value_changed', function (e) {
    getPartners(getParams({ current_page: 1 }));
});

// Search form
document.querySelector('.providers-search')?.addEventListener('submit', function (e) {
    e.preventDefault();
    getPartners(getParams({ current_page: 1 }));
});

document.querySelector('body.single-partners form.wpcf7-form')?.insertAdjacentHTML('afterbegin', '<input type="hidden" name="is_single_partners" value="1">');
document.querySelector('body.single-partners form.wpcf7-form')?.insertAdjacentHTML('afterbegin', `<input type="hidden" name="single_partner_id" value="${document.querySelector('[name="partners_single_id"]').value}">`);